module.exports = __webpack_public_path__ + "static/media/09_Mara.f250a316.png";